import React from "react";
import {
  useLocalParticipant,
  useRoomContext,
} from "@livekit/components-react";
import SpeakingTranslator from "./SpeakingTranslator";

const SpeakingTranslatorLiveKit = (props) => {
  const localParticipant = useLocalParticipant();
  const room = useRoomContext();

  return <SpeakingTranslator {...props} room={room} localParticipant={localParticipant} />;
};

export default SpeakingTranslatorLiveKit;
